import {mapActions, mapGetters, mapMutations} from "vuex";
import {
  sendResetPasswordLink,
  isUserPhoneVerified,
} from "../../../src/api/services/userService.js";

export default {
  computed: {
    ...mapGetters(["viewConfig"]),
  },
  methods: {
    ...mapActions([
      "signUserIn",
      "signUserInFacebook",
      "signUserInGoogle",
      "isGift",
    ]),
    ...mapMutations(["setStoreLoaded"]),
    forgetPassword() {
      this.loading = true;

      let that = this;
      sendResetPasswordLink(that.email, that.currentStoreDoc.ID)
        .then(function (res) {
          if (res.data.status == 200) {
            that.msg =
              "An email has been sent to your address, please follow the instructions on the email to reset your password.";
          } else {
            that.error = res.data.msg;
          }

          that.loading = false;
        })
        .catch(function () {
          that.error = "Failed to send reset password email.";
          that.msg = "";
          that.loading = false;
        });
    },
    switchView(isLogin) {
      this.error = "";
      this.msg = "";
      this.isLogin = isLogin;
    },
    submit() {
      this.error = "";
      this.msg = "";
      if (this.isLogin) this.login();
      else this.forgetPassword();
    },
    login() {
      let that = this;
      this.$validator.validateAll().then(function (valid) {
        if (valid) {
          that.loading = true;
          let user = {
            email: that.email,
            password: that.password,
          };
          that
            .signUserIn(user)
            .then(async (res) => {
              //check mobile verification
              let isNumberVerified = await isUserPhoneVerified();
              that.loading = false;

              // if field is not explicitly set to false, display mobile authentication
              const enableMobileAuthentication = that.viewConfig.EnableMobileAuthentication !== false;
              if (!isNumberVerified && enableMobileAuthentication) {
                if(that.fullScreen){
                  await that.$router.push("/store/" + that.$route.params.storename);
                }
                  that.$emit("need-verification", {
                    id: res.user.uid,
                    ...user,
                    login: true,
                    HQCompanyID: that.hqDoc.ID,
                  });
              } else {
                if(that.fullScreen){
                  await that.$router.push("/store/" + that.$route.params.storename);
                  return
                }
                that.$emit("close-overlay");
              }
            })
            .catch((error) => {
              that.loading = false;
              that.error = error.message;
            });
        }
      });
    },
    facebookLogin() {
      let that = this;
      this.signUserInFacebook()
        .then(() => {
          if (!that.isMobile()){
            if(that.fullScreen){
              that.$router.push("/store/" + that.$route.params.storename );
              return
            }
            that.$emit("close-overlay");
          }
          else {
            if (!that.storeid) that.$router.push("/");
            else {
              if (that.forgift && that.forgift === true)
                that.$router.push(
                  `../../store/${that.storeid}/checkout/giftcards`
                );
              else that.$router.push(`../../store/${that.storeid}/checkout`);
            }
          }
        })
        .catch((error) => {
          that.error = error.message;
        });
    },
    googleLogin() {
      let that = this;
      that.loading = true;
      this.signUserInGoogle()
        .then(async (res) => {
          //check mobile verification
          let isNumberVerified = await isUserPhoneVerified();
          that.loading = false;

          const enableMobileAuthentication = that.viewConfig.EnableMobileAuthentication !== false;
          if (!isNumberVerified && enableMobileAuthentication) {

            that.$emit("need-verification", {
              id: res.user.uid,
              email: res.user.email,
              login: true,
              HQCompanyID:
                that.currentStoreDoc.HQCompanyID || that.currentStoreDoc.ID,
            });
          } else {
            if(that.fullScreen){
              await that.$router.push("/store/" + that.$route.params.storename + "/login");
              return
            }
            that.$emit("close-overlay");
          }
        })
        .catch((error) => {
          that.error = error.message;
          that.loading = false;
        });
    },
  },
};
